<template>
    <div class="modal" :class="showPicture ? '' : 'auto-heigth'" :style="widthModal" :id="id">
        <div class="row modal-loaded">
            <div class="media" v-if="showPicture" style="height: 405.95px;">
                <img src="@/assets/img/foto-modal.jpg" alt="" class="mr-3 rounded-left d-none d-md-inline-block" style="height: 100%; width: auto;">
                <div class="media-body pt-4 pb-4 pr-4 pl-4" :style="overflow ? 'overflow: auto; height: 95%' : ''">
                    <p v-if="size > 0" :style="'font-size:' + size + 'px'" class="text-uppercase"><span v-if="ico" :class="ico"></span> {{ titulo }}</p>
                    <p v-else class="text-uppercase"><span v-if="ico" :class="ico"></span>{{ titulo }}</p>
                    <slot name="body"></slot>
                    <div class="row">
                        <slot name="buttons">
                            <v-button v-if="closeButton" label="Fechar" :click="close"></v-button>
                        </slot>
                    </div>
                </div>
            </div>

            <div v-else class="col-12 pr-5 pl-md-4 pt-4 pb-4 text-center" :style="overflow ? 'overflow: auto; height: 95%' : ''">
                <p v-if="size > 0" :style="'font-size:' + size + 'px'" class="text-uppercase"><span v-if="ico" :class="ico"></span> {{ titulo }}</p>
                <p v-else class="text-uppercase"><span v-if="ico" :class="ico"></span>{{ titulo }}</p>
                <slot name="body"></slot>
                <div class="row">
                    <slot name="buttons">
                        <v-button v-if="closeButton" label="Fechar" :click="close"></v-button>
                    </slot>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
  export default {
    props: {
      titulo: {
        type: String,
        default: null,
      },
      ico: {
        type: String,
        default: null,
      },
      size: {
        type: [Number,String],
        default: 0
      },
      id: {
        type: String,
        default: 'modal_' + _.toString(Math.floor((Math.random() * 10000) + 1)),
      },
      closeButton: {
        type: Boolean,
        default: true,
      },
      showModal: {
        type: Boolean,
        default: false
      },
      showPicture: {
        type: Boolean,
        default: true
      },
      overflow: {
        type: Boolean,
        default: false
      },
      width: {
        type: [Number,String],
        default: null
      },
    },
    computed: {
      widthModal() {
        if(this.width){
          let width = "max-width: "
          if(_.isNumber(this.width)){
            width += _.toString(this.width) + "px !important;"
          }
          else{
            width += this.width + " !important;"
          }
          return width
        }
        return null;
      }
    },
    methods: {
      show(){
        $(() => {
          $('#' + this.id).modal()
        })
      },
      close(){
        $(() => {
          $.modal.close();
        })
      }
    },
    created(){
      if(this.showModal){
        this.show()
      }
    }
  }
</script>

<style>
    #alert_danger_modal{
        color: #721c24;
        background-color: #f8d7da;
        border-color: #f5c6cb;
    }
    #alert_danger_modal.alert-success{
        color: #155724;
        background-color: #c3e6cb;
        border-color: #155724;
    }
    .auto-heigth{
        height: auto !important;
    }
    .blocker{
        z-index: 2 !important;
    }
    .modal{
        position: relative !important;
    }

    #alert_danger_modal.alert-success .button{
        background-color: #155724;
        border-color: #155724;
    }
</style>



// WEBPACK FOOTER //
// src/components/includes/Modal.vue